export default {
  cookiecontent: `当社のウェブサイトおよびその他のオンラインサービスでは、正しく機能し、お客様に最大限にご活用いただくためにCookieを使用しています。また、お客様による当社ウェブサイトの利用状況やインタラクションの分析やソーシャルメディア機能の有効化にもCookieを使用しています。これらのクッキーは、適切なボタンを使用して承認または拒否したり、承認するCookieを管理したりすることができます。一部のCookieを拒否すると、当社ウェブサイトのすべての機能にアクセスできなくなる可能性があることにご注意ください。
    <a href="/cookie" target="_blank">『Cookie政策』</a>。`,
  同意: "受入",
  拒绝: "拒否",
  Cookie政策: "Cookie政策",
  本Cookie政策说明EBCFinancial: `このCookieポリシーは、EBCファイナンシャルグループ（以下「EBC」、「当社」）が当社のウェブサイトwww.ebc.com（以下「ウェブサイト」）でクッキーおよび同様のテクノロジーを使用する方法について説明しています。`,
  什么是Cookie: "1.Cookieとは",
  Cookie是当您浏览EBC: `Cookieとは、EBCのウェブサイトにアクセスした際に、お客様のデバイス（パソコンや携帯電話など）に保存される小さなテキストファイルです。これらのファイルは、ウェブサイトのパフォーマンス向上やウェブサイト所有者への情報提供に主に使用されます。`,
  您可透过以下网站了解更多: "Cookieの詳細については、以下のウェブサイトをご覧ください。",
  我们使用的Cookie类型: "2.当社が使用するCookieの種類",
  tabletop: "",
  Cookie类型: "Cookieの種類",
  说明: "説明",
  必要Cookie: "基本Cookie",
  此类Cookie是网站正常运作所必需: `これらのCookieはウェブサイトが正常に機能するために必要なものであり、無効にすることはできません。これらのクッキーは通常、フォームへの入力やプライバシー設定など、お客様の操作に応じて設定されます。ブラウザでこれらのCookieをブロックしたり、警告を表示したりするように設定することは可能ですが、その場合、サイトの一部が機能しなくなります。`,
  效能分析Cookie: "パフォーマンス（または分析）Cookie",
  此类Cookie协助我们计算访客数与流量来源: `これらのCookieにより、訪問数やトラフィックソースを計算し、サイトのパフォーマンスを測定し、改善することができます。これにより、どのページが最も人気があり、どのページが最も人気がないかを把握し、サイト内での訪問者の動きを把握することができます。`,
  功能性Cookie: "機能Cookie",
  使网站能提供更进阶的功能与个人化体验: `これらのCookieは、ウェブサイトの機能強化とパーソナライズを可能にします。これらのCookieは、当社または当社のウェブサイトにサービスを追加した第三者プロバイダーによって設定される場合があります。これらのCookieを許可しない場合、一部またはすべてのサービスが正常に機能しない可能性があります。`,
  tablebottom: "クッキーは、当社のウェブサイト、商品、およびお申し込み手続きを最大限に活用していただくために利用されます。クッキーポリシーのご利用に同意いただけない場合、またはブラウザの設定でクッキーを受け入れないように設定されている場合、ウェブサイトの一部の機能またはサービスにアクセスできない場合があります。",
  如何管理Cookie: "3.Cookieの管理方法",
  您有权决定是否接受Cookie:
    "Cookieを受け入れるか拒否するかを選択する権利があります。ブラウザの設定を変更することで、Cookieの設定を管理できます。ほとんどのブラウザでは、以下の操作が可能です。",
  查看装置上已安装的Cookie: "デバイスにインストールされているCookieをチェックします",
  删除Cookie: "Cookieを削除",
  封锁Cookie: "Cookieをブロック",
  设定特定网站的Cookie偏好: "特定のウェブサイトのCookieを設定",
  详细操作请参阅您的浏览器说明页:
    "クッキーの管理方法の詳細については、ブラウザのヘルプセクションまたはブラウザに応じて次のリンクをご覧ください。",
  同意h2: "4.同意",
  当您使用本网站: `当社のウェブサイトを使用することにより、お客様は、お客様のデバイスのブラウザでクッキーを拒否するように設定していない限り、当社がお客様のデバイスに上記に定められた種類のクッキーを配置し、本ポリシーに従ってそのデータを使用することに同意するものとします。`,
  政策更新: "5.Cookie政策の更新",
  本Cookie政策可能因应实务或法律改变而更新: `このCookie政策は、慣行または法律の変更に応じて更新されます。重要な変更がある場合は、ウェブサイトにお知らせをご掲載いたします。
          <br />ご不明な点等ございましたら、お気軽にカスタマーサービス
          <a
            class="a-normal"
            href="mailto:cs@ebc.com"
            >cs@ebc.com</a
          >までお問い合わせください。`,
  最后更新时间: "最終更新時間: 2025年6月",
};
